/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PlayerScorecardQueryVariables = {|
  scorecardId: string,
  roundNumber: number,
|};
export type PlayerScorecardQueryResponse = {|
  +liveScorecard: ?$ReadOnlyArray<?{|
    +hole: {|
      +hole: {|
        +holeNum: number
      |}
    |},
    +holeToPar: ?number,
    +prettyToPar: ?string,
    +holeScore: ?number,
  |}>
|};
export type PlayerScorecardQuery = {|
  variables: PlayerScorecardQueryVariables,
  response: PlayerScorecardQueryResponse,
|};
*/


/*
query PlayerScorecardQuery(
  $scorecardId: ID!
  $roundNumber: Int!
) {
  liveScorecard(scorecardId: $scorecardId, roundNumber: $roundNumber) {
    hole {
      hole {
        holeNum
        id
      }
      id
    }
    holeToPar
    prettyToPar
    holeScore
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "roundNumber"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scorecardId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "roundNumber",
    "variableName": "roundNumber"
  },
  {
    "kind": "Variable",
    "name": "scorecardId",
    "variableName": "scorecardId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "holeNum",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "holeToPar",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prettyToPar",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "holeScore",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PlayerScorecardQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "PGATourPlayerScorecardHoleSummaryType",
        "kind": "LinkedField",
        "name": "liveScorecard",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourPlayerScorecardHoleType",
            "kind": "LinkedField",
            "name": "hole",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PGATourEventHoleForRoundType",
                "kind": "LinkedField",
                "name": "hole",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PlayerScorecardQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "PGATourPlayerScorecardHoleSummaryType",
        "kind": "LinkedField",
        "name": "liveScorecard",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourPlayerScorecardHoleType",
            "kind": "LinkedField",
            "name": "hole",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PGATourEventHoleForRoundType",
                "kind": "LinkedField",
                "name": "hole",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6b2e11d4df72aa5040ffa09a522d9bef",
    "id": null,
    "metadata": {},
    "name": "PlayerScorecardQuery",
    "operationKind": "query",
    "text": "query PlayerScorecardQuery(\n  $scorecardId: ID!\n  $roundNumber: Int!\n) {\n  liveScorecard(scorecardId: $scorecardId, roundNumber: $roundNumber) {\n    hole {\n      hole {\n        holeNum\n        id\n      }\n      id\n    }\n    holeToPar\n    prettyToPar\n    holeScore\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c5bb043a3fe7f2bf663cc047dd88fa4f';

module.exports = node;
